'use strict';

module.exports = (app) => app.factory('taskService', /* @ngInject */ function (apiConfig, httpService, sseService) {

	const apiBase = apiConfig.$get().apiUrl;
	const BASE = 'task';

	let currentOpenTaskCount = 0;

	/**
	 * Get open task count for current user
	 * @return {Promise<{count:number}>}
	 */
	async function getTaskCount() {
		try {
			const url = `${apiBase}/${BASE}/count`;
			return httpService.get(url);
		} catch (e) {
			return Promise.reject(e);
		}
	}

	/**
	 * Get open task count for current user
	 * @return {Promise<{myTasks:number,otherTasks:number}>}
	 */
	async function getTaskCountExtended() {
		try {
			const url = `${apiBase}/${BASE}/count/extended`;
			return httpService.get(url);
		} catch (e) {
			return Promise.reject(e);
		}
	}

	/**
	 * Get all tasks for the order with provided orderNumber that are assigned to the currently logged in user
	 * @param orderNumber {string} - order number to get the tasks for
	 * @return {Promise<Object>}
	 */
	function getTasksForOrder(orderNumber) {
		try {
			const url = `${apiBase}/${BASE}/process-variable?variableName=orderNumber&variableValue=${orderNumber}`;
			return httpService.get(url, {isArray: true});
		} catch (e) {
			return Promise.reject(e);
		}
	}

	return {
		getTaskCount,
		getTaskCountExtended,
		getTasksForOrder,
		setOpenTaskCount: (count) => currentOpenTaskCount = count,
		currentOpenTaskCount
	}

});
